module.exports = __webpack_public_path__ + "img/administrador.bf8c2afc.png";